import React from 'react';
import type { ImageFile } from '../../types/chat.types';
import { usePreset } from '../../lib/ThemeContext';

interface ImagePreviewProps {
  images: ImageFile[];
  onRemove: (id: string) => void;
}

/**
 * Image preview component for showing images before sending
 */
export const ImagePreview: React.FC<ImagePreviewProps> = ({ images, onRemove }) => {
  const preset = usePreset();
  const isNevi = preset === 'nevi';

  if (images.length === 0) {
    return null;
  }

  if (isNevi) {
    // NeVi: attachment thumbnails above the input panel — Figma node 1910:19569
    return (
      <div className="wc-flex wc-flex-wrap wc-gap-2" style={{ padding: '0 14px 10px' }}>
        {images.map((image) => (
          <div key={image.id} className="wc-relative wc-group">
            <img
              src={image.preview}
              alt="Preview"
              style={{
                width: '80px',
                height: '80px',
                objectFit: 'cover',
                borderRadius: '12px',
                border: '1px solid rgba(251, 251, 251, 0.15)',
                display: 'block',
              }}
            />
            <button
              onClick={() => onRemove(image.id)}
              className="wc-absolute wc-flex wc-items-center wc-justify-center wc-border-none wc-cursor-pointer"
              style={{
                top: '4px',
                right: '4px',
                width: '20px',
                height: '20px',
                background: 'rgba(33, 33, 33, 0.7)',
                color: '#FBFBFB',
                borderRadius: '6px',
                fontSize: '12px',
                backdropFilter: 'blur(4px)',
                WebkitBackdropFilter: 'blur(4px)',
              }}
              type="button"
              aria-label="Remove image"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="wc-flex wc-flex-wrap wc-gap-2 wc-p-2 wc-border-t wc-border-white/10">
      {images.map((image) => (
        <div key={image.id} className="wc-relative wc-group">
          <img
            src={image.preview}
            alt="Preview"
            className="wc-w-16 wc-h-16 wc-object-cover wc-rounded-lg wc-border wc-border-white/20"
          />
          <button
            onClick={() => onRemove(image.id)}
            className="wc-absolute wc--top-1.5 wc--right-1.5 wc-bg-black/60 wc-text-white wc-rounded-full wc-w-5 wc-h-5 wc-flex wc-items-center wc-justify-center hover:wc-bg-black/80 wc-transition-colors wc-text-xs wc-border-none wc-cursor-pointer"
            type="button"
            aria-label="Remove image"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};
